import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as SimpleAB from 'simpleab';
import * as debug from 'debug';
import * as _ from 'lodash';
import { ConfigProvider } from '../config/config';

SimpleAB.track = (trial, variant) => {
  setTimeout(() => {
    try {
      window['fbq']('trackCustom', 'trial-' + trial + '-' + variant);
    } catch (e) {}
  }, 50);
};

/*

Allows us to control ab tests from configs, looking like this

db.getCollection('configs').insert({
    "key" : "abTests",
    "value" : {
        "onboardingFlow": {
        "name": "onboardingFlowv2",  // optional override for tracking
            "options": [
            {
                "key": "flow1",
                "weight" :1
            },
            {
                "key": "flow2",
                "weight": 1
            }
            ]
        }
    }
})

*/

@Injectable()
export class AbTestsProvider {
  log = debug('app:AbTestsProvider');

  constructor(public config: ConfigProvider) {}

  choose(trial: string, availableOptions: string[]) {
    const configs = _.get(this.config.get('abTests'), trial);

    this.log('choosing for %s', trial);
    if (configs) {
      this.log('conifgs', configs);
      const ab = new SimpleAB(configs.name || trial);
      let count = 0;
      _.each(configs.options, o => {
        // code can handle this option
        if (_.includes(availableOptions, o && o.key)) {
          ++count;
          ab.variant(o.key, o.weight || 1);
        }
      });

      if (count) {
        const variant = ab.choose();
        this.log('chosen', variant);
        return variant;
      } else {
        this.log('no matching options');
      }
    }

    // fallback
    this.log('no configs found');
    const ab = new SimpleAB((configs && configs.name) || trial);
    _.each(availableOptions, a => {
      ab.variant(a, 1);
    });
    return ab.choose();
  }
}



// WEBPACK FOOTER //
// ./src/providers/ab-tests/ab-tests.ts